// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button.button-color {\r\n    background-color: transparent;\r\n    border: none;\r\n    font-family: Roboto, \"Open Sans\", \"Helvetica Neue\", sans-serif;\r\n    min-width: unset;\r\n}\r\n\r\n.button.button-color:hover {\r\n    border: none;\r\n}\r\n\r\n.button.button-color:active {\r\n    background-color: transparent;\r\n}\r\n", ""]);
// Exports
module.exports = exports;
